import { z } from 'zod';
/**
 * Schema for validating JSON primitive values (string, number, boolean, null)
 */
export const JsonPrimitiveSchema = z.union([z.string(), z.number(), z.boolean(), z.null()]);
/**
 * Schema for validating any valid JSON value (primitive, object, or array).
 * Uses z.lazy() for recursive type definition.
 */
export const JsonValueSchema = z.lazy(() => z.union([JsonPrimitiveSchema, z.array(JsonValueSchema), z.record(z.string(), JsonValueSchema)]));
//# sourceMappingURL=JsonValueSchema.js.map